import { format } from "date-fns"

export const REFERRAL_STATUSES = [
  { value: "pre_escrow", label: "Pre-Escrow" },
  { value: "pending", label: "Pending" },
  { value: "contract_canceled", label: "Cancelled" },
]

export const referralSerializer = (list) => {
  if (!list || !Array.isArray(list) || list.length <= 0) return []
  return list.map((item, iter) => ({
    key: iter,
    referralId: item.referral_id || item.id,
    dealId: item.deal_id || item.brokerage_deal_id || null,
    referralName: item.custom_transaction_name || "N/A",
    propertyAddress: (item.property_address && item.property_address.trim()) || "N/A",
    referringAgentName: item.referring_agent_name || "N/A",
    agentEmail: item.agent_email || "N/A",
    clientName: item.client_name || "N/A",
    clientEmail: item.client_email || "N/A",
    status: item.status,
    displayStatus: item.brokerage_display_status
      || REFERRAL_STATUSES.find((s) => s.value === item.status)?.label
      || item.status
      || "N/A",
    createdAt: item.created_at ? format(new Date(item.created_at), "MMM dd, yyyy") : "N/A",
    lastUpdated: item.updated_at ? format(new Date(item.updated_at), "MMM dd, yyyy") : "N/A",
    primaryAgentId: item.primary_agent_id,
    agentId: item.agent_id || item.primary_agent_id,
    agentAvatar: item.agent_avatar,
    currentStep: item.current_referral_step,
    brokerageDisplayName: item.brokerage_display_name,
    state: item.state,
  }))
}

export const getStatusColor = (status) => {
  switch (status) {
    case "pre_escrow":
      return "#F0C3A2"
    case "pending":
      return "#FAEBA6"
    case "closed":
      return "#B3E4C7"
    case "canceled":
    case "contract_canceled":
      return "#EBBAB5"
    default:
      return "#D2D8D8"
  }
}
